import { BANNER_EVENT_DATA, BANNER_EVENT_ERROR, BANNER_EVENT_FETCH } from "./constants";
import { BannerEventDataAction, BannerEventErrorAction, BannerEventFetchAction, BannerEventQuery, BannerEventResponse } from "./types";

export function bannerEventFetch(query: BannerEventQuery): BannerEventFetchAction {
    return {
        type: BANNER_EVENT_FETCH,
        payload: query
    };
}

export function bannerEventData(data: BannerEventResponse): BannerEventDataAction {
    return {
        type: BANNER_EVENT_DATA,
        payload: data
    };
}

export function bannerEventError(error: any): BannerEventErrorAction {
    return {
        type: BANNER_EVENT_ERROR,
        payload: error
    };
}
